import { useQuery } from "@tanstack/react-query";
import { useCommonStore } from "../../store";
import { getTypeTransactionApi } from "../../services/type-transaction/get.type.transaction.api";

export const useGetAllTypeTransactionApi = () => {
  const { reload } = useCommonStore();
  const { data, isLoading } = useQuery({
    queryKey: ["type-transaction", reload],
    queryFn: () => getTypeTransactionApi(),
    enabled: true,
  });
  return {
    typeTransaction: data,
    isLoading,
  };
};
